module.exports = __webpack_public_path__ + "static/Archia-Regular.0b592a34.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Archia-Regular.ttf
// module id = 109
// module chunks = 35783957827783 231608221292675